
import { Component, Mixins, Prop, Ref } from "vue-property-decorator";
import { SEO, ApiFactory } from "_core";
import { getCMSData } from "_mixins";
import { ApiRoutes, MainSettings } from "_types";
import { Routes } from "../../routes";
import { HomePageCMS } from "./types";

import HomeWrapper from "./source/Wrapper.vue";

@Component({
  metaInfo() {
    return SEO.getHomePageMetaData(this.settings && this.settings.seo);
  },
  components: { HomeWrapper },
})
export default class HomePage extends Mixins(getCMSData) {
  @Prop() settings: MainSettings;
  @Ref() homepageRef: HomeWrapper;

  setPageToShow: any = null;
  CMSData: HomePageCMS = null;

  initMixin() {
    this.initCMS(ApiRoutes.HomePage, this.$route);
  }

  onCMSLoad(data) {
    if (ApiFactory.isAuth(this.$route)) {
      const matchedRoute = Routes.find(
        (block) => block.name === data.post_type
      );
      if (matchedRoute) this.setPageToShow = matchedRoute.component;
    }
  }

  public calcAfterAnim() {
    if (this.homepageRef) this.homepageRef.calcAfterAnim();
  }
}
